<div class="sidenav-hold">
  @if (hasIconTypeMenuItem) {
  <div class="icon-menu mb-16">
    <!-- Icon menu separator -->
    <div class="mb-16 nav-item-sep">
      <mat-divider [ngStyle]="{margin: '0 -24px'}"></mat-divider>
      <span class="text-muted icon-menu-title">{{iconTypeMenuTitle}}</span>
    </div>
    <!-- Icon menu items -->
    @for (item of menuItems; track item) {
    <div class="icon-menu-item">
      @if (!item.disabled && item.type === 'icon') {
      <button
        mat-raised-button
        [matTooltip]="item.tooltip"
        routerLink="/{{item.state}}"
        routerLinkActive="mat-bg-primary"
      >
        @if (item.icon) {
        <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
        } @if (item.svgIcon) {
        <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
        }
      </button>
      }
    </div>
    }
  </div>
  }

  <ul appDropdown class="sidenav">
    @for (item of menuItems; track item) {
    <li appDropdownLink routerLinkActive="open">
      @if (item.type === 'separator') {
      <div class="nav-item-sep">
        <mat-divider></mat-divider>
        <span class="text-muted">{{item.name | translate}}</span>
      </div>
      } @if (!item.disabled && item.type !== 'separator' && item.type !== 'icon') {
      <div class="lvl1">
        @if (item.type === 'link' && item.state==='orders/create-order') {
        <button
          matRipple
          class="create-order-button"
          (click)="showCreateOrderOptionsDialog()"
          appDropdownToggle
        >
          @if (item.icon) {
          <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
          } @if (item.svgIcon) {
          <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
          }
          <span class="item-name lvl1">{{item.name | translate}}</span>
        </button>
        } @if (item.type === 'link' && item.state!=='orders/create-order') {
        <a routerLink="/{{item.state}}" appDropdownToggle matRipple>
          @if (item.icon) {
          <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
          } @if (item.svgIcon) {
          <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
          }
          <span class="item-name lvl1">{{item.name | translate}}</span>
          <span fxFlex></span>
          @for (badge of item.badges; track badge) {
          <span
            class="menuitem-badge mat-bg-{{ badge.color }}"
            [ngStyle]="{background: badge.color}"
            >{{ badge.value }}</span
          >
          }
        </a>
        } @if (item.type === 'extLink') {
        <a [href]="item.state" appDropdownToggle matRipple target="_blank">
          @if (item.icon) {
          <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
          }
          <span class="item-name lvl1">{{item.name | translate}}</span>
          <span fxFlex></span>
          @for (badge of item.badges; track badge) {
          <span
            class="menuitem-badge mat-bg-{{ badge.color }}"
            [ngStyle]="{background: badge.color}"
            >{{ badge.value }}</span
          >
          }
        </a>
        }
        <!-- DropDown -->
        @if (item.type === 'dropDown') {
        <a appDropdownToggle matRipple>
          @if (item.icon) {
          <mat-icon class="sidenav-mat-icon">{{item.icon}}</mat-icon>
          } @if (item.svgIcon) {
          <mat-icon [svgIcon]="item.svgIcon" class="svgIcon"></mat-icon>
          }
          <span class="item-name lvl1">{{item.name | translate}}</span>
          <!-- <button mat-button role="button"class="btn btn-danger">Basic</button> -->
          <span fxFlex></span>
          <!-- <div mat-dialog-actions align="end"><button mat-raised-button color="warn" class="small">{{item.value}}<span
              class="glyphicon glyphicon-{{Sign}}"></span></button></div> -->
          <span fxFlex></span>
          @for (badge of item.badges; track badge) {
          <span
            class="menuitem-badge mat-bg-{{ badge.color }}"
            [ngStyle]="{background: badge.color}"
            >{{ badge.value }}</span
          >
          }
          <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
        </a>
        }
        <!-- LEVEL 2 -->
        @if (item.type === 'dropDown') {
        <ul class="submenu lvl2" appDropdown>
          @for (itemLvL2 of item.sub; track itemLvL2) {
          <li appDropdownLink routerLinkActive="active">
            @if (itemLvL2.type !== 'dropDown') {
            <a
              routerLink="{{item.state ? '/'+item.state : ''}}/{{itemLvL2.state == 'store'  ?itemLvL2.state+'/:'+itemLvL2.id:itemLvL2.state}}"
              [ngStyle]="{'background-color': itemLvL2.state===activeRoute? '$mm-bg-accent !important' : '$mm-bg-primary'}"
              appDropdownToggle
              matRipple
            >
              <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
              <span fxFlex></span>
              <div
                class="order-count"
                [ngClass]="{
                                'reverse': itemLvL2.state === 'processing' || itemLvL2.state === 'deliverypickup'}"
                [ngStyle]="{'background-color':itemLvL2.color1,'color':'white'}"
              >
                {{itemLvL2.value | translate}}
              </div>
            </a>
            } @if (itemLvL2.type === 'dropDown') {
            <a appDropdownToggle matRipple>
              <span class="item-name lvl2">{{itemLvL2.name | translate}}</span>
              <span fxFlex></span>
              <div mat-dialog-actions align="end">
                <button mat-raised-button [ngStyle]="{background: itemLvL2.color}">
                  {{itemLvL2.value | translate}}
                </button>
              </div>
              <mat-icon class="menu-caret">keyboard_arrow_right</mat-icon>
            </a>
            }
            <!-- LEVEL 3 -->
            @if (itemLvL2.type === 'dropDown') {
            <ul class="submenu lvl3" appDropdown>
              @for (itemLvL3 of itemLvL2.sub; track itemLvL3) {
              <li appDropdownLink routerLinkActive="open">
                <a
                  routerLink="{{item.state ? '/'+item.state : ''}}{{itemLvL2.state ? '/'+itemLvL2.state : ''}}/{{itemLvL3.state}}"
                  appDropdownToggle
                  matRipple
                >
                  <span class="item-name lvl3">{{itemLvL3.name | translate}}</span>
                </a>
              </li>
              }
            </ul>
            }
          </li>
          }
        </ul>
        }
      </div>
      }
    </li>
    }
  </ul>
</div>
